import type { HelpFile } from '../../types/help'
import { MockLoginTestIds } from '../../../testids/MockLoginTestIds'

export const mockLoginHelp: HelpFile = {
  texts: {
    [MockLoginTestIds.mockLoginSubmit]: null,
  },
}
